export const SET_OFFERS_LOADING = "SET_OFFERS_LOADING"
export const SET_OFFERS = "SET_OFFERS"
export const MAKE_OFFERS_PAGE_REQUEST = "MAKE_OFFERS_PAGE_REQUEST"
export const ON_SUCCESSFUL_OFFERS_PAGE_REQUEST = "ON_SUCCESSFUL_OFFERS_PAGE_REQUEST"
export const ON_FAILED_OFFERS_PAGE_REQUEST = "ON_FAILED_OFFERS_PAGE_REQUEST"
export const MAKE_OFFER_PAGE_REQUEST = "MAKE_OFFER_PAGE_REQUEST"
export const ON_SUCCESSFUL_OFFER_PAGE_REQUEST = "ON_SUCCESSFUL_OFFER_PAGE_REQUEST"
export const ON_FAILED_OFFER_PAGE_REQUEST = "ON_FAILED_OFFER_PAGE_REQUEST"
export const CLEAR_OFFERS_ROUTES = "CLEAR_OFFERS_ROUTES"
export const MAKE_ROUTE_REQUEST = "MAKE_ROUTE_REQUEST"
export const ON_SUCCESSFUL_ROUTE_REQUEST = "ON_SUCCESSFUL_ROUTE_REQUEST"
export const ON_FAILED_ROUTE_REQUEST = "ON_FAILED_ROUTE_REQUEST"
export const SET_ROUTES_LOADING = "SET_ROUTES_LOADING"
export const SET_ROUTE = "SET_ROUTE"
export const UPDATE_SETTINGS = "UPDATE_SETTINGS"
export const SET_CURRENT_ROUTE_TO_FETCH = "SET_CURRENT_ROUTE_TO_FETCH"
export const SET_HOOVERED_OFFER = "SET_HOOVERED_OFFER"

export const SET_TARGET_PLACE = "SET_TARGET_PLACE"
export const OPEN_TOO_FAR_AWAY_MODAL = "OPEN_TOO_FAR_AWAY_MODAL"
export const HIDE_TOO_FAR_AWAY_MODAL = "HIDE_TOO_FAR_AWAY_MODAL"

export const SET_CURRENT_VIEW = "SET_CURRENT_VIEW";

export const SET_ROUTE_TYPE = 'SET_ROUTE_TYPE';